var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTasklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_578_11400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.95 23.14H59.37C60.47 23.14 61.37 22.24 61.37 21.14C61.37 20.04 60.47 19.14 59.37 19.14H20.95C19.85 19.14 18.95 20.04 18.95 21.14C18.95 22.24 19.85 23.14 20.95 23.14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.95 38.08H59.37C60.47 38.08 61.37 37.18 61.37 36.08C61.37 34.98 60.47 34.08 59.37 34.08H20.95C19.85 34.08 18.95 34.98 18.95 36.08C18.95 37.18 19.85 38.08 20.95 38.08Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.53 53.02H59.37C60.47 53.02 61.37 52.12 61.37 51.02C61.37 49.92 60.47 49.02 59.37 49.02H45.53C44.43 49.02 43.53 49.92 43.53 51.02C43.53 52.12 44.43 53.02 45.53 53.02",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9099 46.48L34.5899 43.16L25.5099 52.24L21.9499 48.66L18.6299 52L25.4899 58.86L25.5099 58.84L25.5299 58.86L37.9099 46.48Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_578_11400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.74,
    height: 39.72,
    fill: "white",
    transform: "translate(18.6299 19.14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasklist);
export default __webpack_public_path__ + "static/media/tasklist.73dc43d423d0651c87b7027fe80956ff.svg";
export { ForwardRef as ReactComponent };